import { render, staticRenderFns } from "./PhdItem.vue?vue&type=template&id=66247690&"
import script from "./PhdItem.vue?vue&type=script&lang=js&"
export * from "./PhdItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports